/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

type ExportModalProps = {
  show: boolean
  onClose: () => void
  exportStatus: string
  setExportStatus: (s: string) => void
  onExport: () => void
}

// Puoi mantenere statusOptions locali o importarle dal parent
const statusOptions = [
  'Tutti',
  'Pianificazione','Montaggio','Sviluppo','Testing','Deploying','Vendibile','Manutenzione'
]

export const ExportModal: React.FC<ExportModalProps> = ({
  show,
  onClose,
  exportStatus,
  setExportStatus,
  onExport,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      contentClassName="mw-600px"
    >
      <Modal.Header closeButton>
        <Modal.Title>Esporta simulazioni</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>Seleziona stato:</Form.Label>
        <Form.Select
          value={exportStatus}
          onChange={e => setExportStatus(e.target.value)}
        >
          {statusOptions.map(s => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </Form.Select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annulla
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            onExport()
            onClose()
          }}
        >
          Esporta
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
